import { ErrorOutline } from '@mui/icons-material';
import { Chip } from '@mui/material';
import StateHandlerComponent from 'components/StateHandlerComponent/StateHandlerComponent';
import useDisplayWarnings from 'pages/Study/hooks/useDisplayWarnings';
import { useGetStudyIsLoading } from 'stores/study/StudyStore';

const StudyAnalysisWarnings = (props: { analysisId: string }) => {
    const getStudyIsLoading = useGetStudyIsLoading();

    const { hasNoPoints, hasNoName, hasDuplicateName, hasNonMNICoordinates } = useDisplayWarnings(props.analysisId);

    return (
        <StateHandlerComponent isLoading={getStudyIsLoading} isError={false} loaderSize={20}>
            {hasNoPoints && (
                <Chip
                    sx={{ margin: '2px', marginBottom: '1rem' }}
                    icon={<ErrorOutline />}
                    label="This analysis has no coordinates"
                    color="warning"
                />
            )}
            {hasNoName && (
                <Chip
                    sx={{ margin: '2px', marginBottom: '1rem' }}
                    icon={<ErrorOutline />}
                    label="No analysis name"
                    color="warning"
                />
            )}
            {hasDuplicateName && (
                <Chip
                    sx={{ margin: '2px', marginBottom: '1rem' }}
                    icon={<ErrorOutline />}
                    label="Duplicate analysis name"
                    color="warning"
                />
            )}
            {hasNonMNICoordinates && (
                <Chip
                    sx={{ margin: '2px', marginBottom: '1rem' }}
                    icon={<ErrorOutline />}
                    label="This analysis may contain non MNI coordinates"
                    color="warning"
                />
            )}
        </StateHandlerComponent>
    );
};

export default StudyAnalysisWarnings;
